import { render, staticRenderFns } from "./verificate.vue?vue&type=template&id=6f41042e&scoped=true&"
import script from "./verificate.vue?vue&type=script&lang=js&"
export * from "./verificate.vue?vue&type=script&lang=js&"
import style0 from "./verificate.vue?vue&type=style&index=0&id=6f41042e&scoped=true&lang=scss&"
import style1 from "./verificate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f41042e",
  null
  
)

export default component.exports